import { FunctionComponent, ReactElement, useMemo } from 'react';
import { Button, ButtonProps } from '@mui/material';

interface ExportButtonProps {
	label: string;
	type: 'primary' | 'secondary';
	onClick: () => void;
	disabled?: boolean;
}

const PRIMARY_EXPORT_BUTTON_PROPS = {
	size: 'large',
	variant: 'contained',
} as Partial<ButtonProps>;

const SECONDARY_EXPORT_BUTTON_PROPS = {
	variant: 'outlined',
} as Partial<ButtonProps>;

const ExportButton: FunctionComponent<ExportButtonProps> = ({
	label,
	type,
	onClick,
	disabled,
}): ReactElement => {
	const props = useMemo(() => {
		const props = type === 'primary' ? PRIMARY_EXPORT_BUTTON_PROPS : SECONDARY_EXPORT_BUTTON_PROPS;
		return { ...props, onClick, disabled };
	}, [type, onClick, disabled]);

	return (
		<Button {...props} className="export-button">
			{label}
		</Button>
	);
};

export default ExportButton;
